import { Components, Theme } from "@mui/material";

export const MuiCircularProgress: Components<Theme>["MuiCircularProgress"] = {
  defaultProps: {
    thickness: 10,
  },
};
